// extracted by mini-css-extract-plugin
export var root = "blog-post-module--root--RiA2V";
export var title = "blog-post-module--title--FdtC1";
export var mainImage = "blog-post-module--mainImage--2Vc66";
export var grid = "blog-post-module--grid--1-O6V";
export var mainContent = "blog-post-module--mainContent--3wg8R";
export var metaContent = "blog-post-module--metaContent--3IN1L";
export var publishedAt = "blog-post-module--publishedAt--1gbtI typography-module--small--2TksD";
export var categories = "blog-post-module--categories--24c4x";
export var categoriesHeadline = "blog-post-module--categoriesHeadline--1Ad8x typography-module--base--34V38";